<template>
    <div
        class="drip-form relative"
        :class="{ 'drip-form--card bg-blue-500 text-white p-4 lg:p-10 base-responsive-rounding': card }"
        @submit="onSubmit"
    >
        <div v-if="card && cardTitle" class="header-3 mb-8">
            {{ cardTitle }}
        </div>

        <div v-if="embedCode" ref="embed" class="drip-form__embed" v-html="sanitizedEmbedCode"></div>

        <!-- fallback: the default newsletter subscription form -->
        <form
            v-else
            id="drip-ef-396821546"
            action="https://www.getdrip.com/forms/396821546/submissions"
            method="post"
            data-drip-embedded-form="396821546"
        >
            <div data-drip-attribute="description"></div>

            <div>
                <label for="drip-last-name">Vezetéknév</label><br />
                <input id="drip-last-name" type="text" name="fields[last_name]" value="" />
            </div>

            <div>
                <label for="drip-first-name">Keresztnév</label><br />
                <input id="drip-first-name" type="text" name="fields[first_name]" value="" />
            </div>

            <div>
                <label for="drip-email">E-mail</label><br />
                <input id="drip-email" v-model.trim="email" type="email" name="fields[email]" />
            </div>

            <fieldset style="padding-top: 0.5rem">
                <input id="69903" type="checkbox" name="fields[kulturális]" value="Kulturális hírlevelet is kérek" />
                <label for="69903">Kulturális hírlevelet is kérek</label><br />
            </fieldset>

            <fieldset>
                <input id="69905" type="checkbox" name="fields[családi]" value="Családi hírlevelet is kérek" />
                <label for="69905">Családi hírlevelet is kérek</label><br />
            </fieldset>

            <div>
                <input id="drip-eu-consent-denied" type="hidden" name="fields[eu_consent]" value="denied" />
                <input
                    id="drip-eu-consent"
                    v-model="acceptPolicy"
                    type="checkbox"
                    name="fields[eu_consent]"
                    value="granted"
                />
                <label for="drip-eu-consent">
                    A checkbox bepipálásával hozzájárulok, hogy az adatkezelő a most megadott személyes adataimat a
                    GDPR, továbbá az
                    <a
                        href="https://ligetbudapest.hu/storage/43822/2026_Adatkezel%C3%A9si_t%C3%A1j%C3%A9koztat%C3%B3_LigetBudapest_h%C3%ADrlev%C3%A9l.pdf"
                    >
                        Adatkezelési Tájékoztató
                    </a>
                    feltételei szerint kezelje. Tudomásul veszem, hogy a GDPR 7. cikk (3) bekezdése szerint a
                    hozzájárulásomat bármikor visszavonhatom, akár egy kattintással.*
                </label>
            </div>

            <input type="hidden" name="fields[eu_consent_message]" value="" />

            <div style="display: none" aria-hidden="true">
                <label for="website">Website</label><br />
                <input id="website" type="text" name="website" tabindex="-1" autocomplete="false" value="" />
            </div>
            <input id="tags_" type="hidden" name="tags[]" value="Liget Budapest összes feliratkozó" tabindex="-1" />

            <div>
                <input
                    type="submit"
                    value="Feliratkozom"
                    data-drip-attribute="sign-up-button"
                    :disabled="!isEmailValid || !acceptPolicy"
                />
            </div>
        </form>
    </div>
</template>

<script>
const SUBMITTED_KEY = 'drip-form-submitted';
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
    name: 'DripForm',
    props: {
        card: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        embedCode: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            acceptPolicy: false,
            email: '',
        };
    },
    computed: {
        isEmailValid() {
            return EMAIL_PATTERN.test(this.email);
        },
        // the default title belongs to the fallback newsletter form only
        cardTitle() {
            if (this.title) return this.title;

            return this.embedCode ? null : 'További izgalmas tartalmakért iratkozz fel hírlevelünkre!';
        },
        // Drip's own <style> uses #drip-ef-* id selectors that would override assets/styles/lib/_drip.pcss
        sanitizedEmbedCode() {
            return this.embedCode
                ? this.embedCode.replace(/<style[\s\S]*?<\/style>/gi, '').replace(/<script[\s\S]*?<\/script>/gi, '')
                : null;
        },
        // eslint-disable-next-line vue/return-in-computed-property
    },
    mounted() {
        this.bindEmbedConsent();
        this.clearIfSubmitted();
        window.addEventListener('pageshow', this.clearIfSubmitted);
    },
    beforeDestroy() {
        window.removeEventListener('pageshow', this.clearIfSubmitted);
    },
    methods: {
        // like the built-in form, keep submit disabled until the GDPR consent checkbox is ticked
        bindEmbedConsent() {
            if (!this.$refs.embed) return;

            const consent = this.$refs.embed.querySelector('input[type="checkbox"][name="fields[eu_consent]"]');
            const submit = this.$refs.embed.querySelector('[type="submit"]');

            if (!consent || !submit) return;

            this.syncEmbedConsent = () => (submit.disabled = !consent.checked);
            consent.addEventListener('change', this.syncEmbedConsent);
            this.syncEmbedConsent();
        },
        // the form posts to Drip and redirects to their thank you page, so the fields are only
        // cleared when the user comes back to this page (see clearIfSubmitted)
        onSubmit() {
            try {
                sessionStorage.setItem(SUBMITTED_KEY, '1');
            } catch (e) {}
        },
        // runs on mount (fresh page load) and on pageshow (restored from the back/forward cache)
        clearIfSubmitted() {
            try {
                if (!sessionStorage.getItem(SUBMITTED_KEY)) return;
                sessionStorage.removeItem(SUBMITTED_KEY);
            } catch (e) {
                return;
            }

            this.$el.querySelectorAll('form').forEach((form) => form.reset());
            this.acceptPolicy = false;
            this.email = '';
            if (this.syncEmbedConsent) this.syncEmbedConsent();
        },
    },
};
</script>

<style scoped></style>
